import { render, staticRenderFns } from "./shipping-info.vue?vue&type=template&id=d62b64d0&scoped=true"
import script from "./shipping-info.vue?vue&type=script&lang=js"
export * from "./shipping-info.vue?vue&type=script&lang=js"
import style0 from "./shipping-info.vue?vue&type=style&index=0&id=d62b64d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62b64d0",
  null
  
)

export default component.exports